import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { useSkinAnalyzerVisibility } from '../hooks/useAnalyzerVisibility';
import { skinAnalyserMessages } from '../messages';
import { StyledDescription } from '../styled';

export const Description = () => {
  const { isVariant2 } = useSkinAnalyzerVisibility();
  return (
    <StyledDescription isVariant2={isVariant2}>
      <FormattedMessage
        {...skinAnalyserMessages[
          isVariant2
            ? 'skinAnalyserDescriptionVariant2'
            : 'skinAnalyserDescriptionVariant1'
        ]}
      />
    </StyledDescription>
  );
};
